<template>
  <UiModal :show="showAmount" title="排行榜奖励" iconType="ranking_1" @close="close">
    <div class="bonus">
      <!-- 排行榜奖励 -->
      <div class="bonus-box">
        <p class="title">【基础规则】</p>
        <p>
          1. 给战队赠送礼物可以为该战队增加「人气值」，同时个人可以获得「贡献值」，「战队人气值」=「个人贡献值」
        </p>
        <p>
          2. 累计人气贡献：累计「贡献值」达到不同阶段可解锁【贡献奖励】
        </p>

        <p class="title">【温馨提示】</p>
        <p>1. 礼物获得途径：</p>
        <p> a. 完成每日任务；</p>
        <p> b. 完成累计人气贡献任务；</p>
        <p> c. 每日商城领取；</p>
        <p> d. 游戏内使用「糖果」「赛事币」购买</p>

        <p>
          2. 送礼功能位置：
        </p>
        <p> a. 直播界面下方「助威」按钮</p>
        <p> b. 战队人气值界面「送礼」按钮</p>
        <p>3. 特别注意，【游戏内】礼物（如金玫瑰）与【赛事中心】礼物并不互通</p>
        <p class="title">【特殊奖励】</p>

        <p>
          1. 「个人贡献值」排名第一的玩家可获得全新「梦幻皮肤」（限时使用）、「第六届锦标赛」限定称号（第一专属，限时使用）、永久限定头像（第一专属）；
        </p>
        <p>
          2. 「个人贡献值」排名2-10的玩家可获得「第六届锦标赛」限定称号（前十专属，限时使用）、永久限定头像（前十专属）；
        </p>
        <p>
          3. 「人气值」排名第一的战队所有队员可获得「第六届锦标赛」专属人气称号（限时使用）、永久限定头像。
        </p>
      </div>
    </div>
  </UiModal>
</template>

<script setup>
import { ref } from 'vue'
import { useModal } from '@/composables/useModal'
import UiModal from '@/components/ui-modal.vue'

const showAmount = ref(false)
const { close } = useModal('ranking-rules', showAmount)
</script>

<style lang="scss" scoped>
.bonus {
  height: 100%;
  box-sizing: border-box;
  padding: 32px 32px 50px 58px;

  .bonus-box {
    height: 100%;
    overflow-y: scroll;
    padding-right: 2%;
    padding-left: 25px;
    color: #666;
    font-size: 20px;

    .title {
      position: relative;
      color: #333;
      font-size: 24px;
      margin: 40px 0 10px;
      &::before {
        content: '';
        position: absolute;
        top: 6px;
        left: -25px;
        width: 27px;
        height: 27px;
        @include icon_status('rule_bullet');
      }

      &:first-child {
        margin-top: 2px;
      }
    }
  }
}
</style>
